export default {"src":"/pro/_next/static/media/orderbook-bids-and-asks-icon.bd85a0a5.svg","height":21,"width":24,"blurWidth":0,"blurHeight":0};